import React from 'react';
import * as styles from './LinkDisclaimer.module.scss';
import useInAppBrowser from '../../hooks/useInAppBrowser';
import { IconEyeClosed } from '../../assets/SvgSprite';

const LinkDisclaimer = ({ url, v2 = false }) => {
  const { handleLinkClick } = useInAppBrowser({ url });

  const Link = ({ children }) => (
    <a
      className={styles.linkCardDisclaimerButton}
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={handleLinkClick}
    >
      {children}
    </a>
  );

  return (
    <div
      className={v2 ? styles.linkCardDisclaimerV2 : styles.linkCardDisclaimerV1}
    >
      <IconEyeClosed fill={v2 ? '#fff' : '#000'} />
      <span className={styles.linkCardDisclaimerTitle}>
        18+ Content Warning
      </span>
      <p className={styles.linkCardDisclaimerText}>
        This link may contain graphic or adult content.
      </p>
      <Link>Continue</Link>
    </div>
  );
};

export default LinkDisclaimer;
